import React from 'react';
import { useSelector } from 'react-redux';
import Sidebar from '../../components/customer/Sidebar'; 
import '../../global.css';
import loaderImg from '../../images/loader.gif';
import { selectIsLoading } from '../../redux/loadingSlice';

// Memoize the layout component
const Layout = React.memo(({ children }) => {

  return (
    <div className="dashboard-container flex customer-app">
      <Sidebar />
       <LoadingOverlay />
      {children}
    </div>
  );
});

const LoadingOverlay = () => {
  const isLoading = useSelector(selectIsLoading);

  if (!isLoading) return null;

  return (
    <div style={overlayStyle}>
      <img src={loaderImg} alt="Loading..." style={loaderImageStyle} />
    </div>
  );
};
 
const overlayStyle = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 100000, // Ensure loader is on top
};

const loaderImageStyle = {
  width: '360px',
  height: '250px', 
};

export default Layout;